export default {
  NEW: "new",
  OPEN: "open",
  CANCEL: "cancel",
  isOpen: function(orderStatus) {
    if (orderStatus == this.OPEN) {
      return true;
    }
    return false;
  }
};
